import React from 'react';
import { ListIcon, ChevronDownIcon } from 'lucide-react';
import { tocItems } from '../data/articleLists';
import { useActiveSection } from '../hooks/useActiveSection';
const ids = tocItems.map(item => item.id);
export function TableOfContents() {
  const active = useActiveSection(ids);
  return <>
      <details className="glass group mb-10 rounded-2xl lg:hidden" data-id="element-240" data-mp="2m9280czwoq8f">
        <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 text-sm font-semibold text-ink" data-id="element-241" data-mp="27d2zj18vwo2r">
          <span className="flex items-center gap-2" data-id="element-242" data-mp="2ccz3j0hl0fib">
            <ListIcon className="h-4 w-4 text-aurora-cyan" aria-hidden="true" data-id="element-243" data-mp="1yc4v4hujaejn" />
            On this page
          </span>
          <ChevronDownIcon className="h-4 w-4 text-muted transition-transform duration-200 group-open:rotate-180" aria-hidden="true" data-id="element-244" data-mp="23apuyg5viw7k" />
        </summary>
        <ol className="border-t border-line px-5 py-3" data-id="element-245" data-mp="3sqxmu5saql6b">
          {tocItems.map(item => <li key={item.id} data-id="element-246" data-mp="1j3cx43ymbn8">
              <a href={`#${item.id}`} className="block py-2 text-sm text-muted hover:text-ink" data-id="element-247" data-mp="1mlpcg90x59aw">
                {item.label}
              </a>
            </li>)}
        </ol>
      </details>

      <nav aria-label="Table of contents" className="sticky top-24 hidden lg:block" data-id="element-248" data-mp="1wbinn8x5fmem">
        <p className="mb-4 text-sm font-semibold text-ink" data-id="element-249" data-mp="1wdd0dzy9o87m">On this page</p>
        <ol className="space-y-0.5 border-l border-line" data-id="element-250" data-mp="1rcyyz0r67wik">
          {tocItems.map(item => {
          const isActive = active === item.id;
          return <li key={item.id} data-id="element-251" data-mp="zm17u14gcjz7">
                <a href={`#${item.id}`} aria-current={isActive ? 'location' : undefined} className={`-ml-px block border-l py-1.5 pl-4 text-sm transition-colors duration-150 ${isActive ? 'border-aurora-cyan text-ink' : 'border-transparent text-faint hover:text-muted'}`} data-id="element-252" data-mp="zn2n6hsi3smq">
                  {item.label}
                </a>
              </li>;
        })}
        </ol>
      </nav>
    </>;
}